import LocationList from './LocationList.container';

export default LocationList;
